import React, { Fragment } from "react";
import styled from "styled-components";
import ReplyIcon from "@material-ui/icons/Reply";

import PrimaryButton from "./PrimaryButton";

const SaveAndReturnButton = ({ onClick, ...other }) => (
  <PrimaryButton onClick={onClick} {...other}>
    <ReplyIcon />
    <div>SAVE &amp; RETURN</div>
  </PrimaryButton>
);
export default SaveAndReturnButton;
